import { Part } from '@/types';

const HEADING_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

export type SummarySection = {
  title: string;
  parts: Part[];
};

export type SectionedContent = {
  sections: Array<SummarySection>;
};

const isHeading = (part: Part, tagName?: string): boolean =>
  part.type === 'element' &&
  (tagName === undefined
    ? (HEADING_TAGS as readonly string[]).includes(part.tagName)
    : part.tagName === tagName);

const textOf = (part: Part): string =>
  part.type === 'text'
    ? part.content
    : (part.children ?? []).map(textOf).join('');

const findBoundaryTag = (parts: Part[]): string | undefined =>
  HEADING_TAGS.find(tag => parts.some(part => isHeading(part, tag)));

export const splitPartsIntoSections = (parts: Part[]): SectionedContent => {
  const boundaryTag = findBoundaryTag(parts);
  const sections: Array<SummarySection> = [];

  for (const part of parts) {
    if (boundaryTag !== undefined && isHeading(part, boundaryTag)) {
      sections.push({ title: textOf(part).trim(), parts: [] });
    } else if (sections.length > 0) {
      sections[sections.length - 1].parts.push(part);
    }
  }

  return { sections };
};
